export default __webpack_public_path__ + "static/media/Prologue_Haven2US.8d85c729.svg";